var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "sidebar-block" } }, [
    _c("div", { staticClass: "go-sidebar" }, [
      _c("div", { staticClass: "go-sidebar-header" }, [
        _c("div", { staticClass: "go-sidebar-title" }, [
          _vm._v(_vm._s(_vm.$t("my-create.common.label.title-front"))),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "go-sidebar-body" }, [
        _c("div", { staticClass: "go-sidebar-body-inner overflow-y-scroll" }, [
          _c("div", { staticClass: "go-panel sub-link" }, [
            _c("div", { staticClass: "go-panel-body" }, [
              _c("div", { staticClass: "go-list-item" }, [
                _c(
                  "a",
                  {
                    class: [
                      "go-list-link",
                      !_vm.currentRoute ||
                      _vm.currentRoute.includes("ask-goover")
                        ? "active"
                        : "",
                    ],
                    on: {
                      click: function ($event) {
                        return _vm.goTo("/my-create/ask-goover")
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("my-create.common.navbar.ask-goover")) +
                        "\n              "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    class: [
                      "go-list-link",
                      _vm.currentRoute && _vm.currentRoute.includes("report")
                        ? "active"
                        : "",
                    ],
                    on: {
                      click: function ($event) {
                        return _vm.goTo("/my-create/report")
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("my-create.common.navbar.report")) +
                        "\n              "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    class: [
                      "go-list-link",
                      _vm.currentRoute &&
                      _vm.currentRoute.includes("journalist-note")
                        ? "active"
                        : "",
                    ],
                    on: {
                      click: function ($event) {
                        return _vm.goTo("/my-create/journalist-note")
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("my-create.common.navbar.journal")) +
                        "\n              "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    class: [
                      "go-list-link",
                      _vm.currentRoute &&
                      _vm.currentRoute.includes("social-media-posting")
                        ? "active"
                        : "",
                    ],
                    on: {
                      click: function ($event) {
                        return _vm.goTo("/my-create/social-media-posting")
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("my-create.common.navbar.social")) +
                        "\n              "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    class: [
                      "go-list-link",
                      _vm.currentRoute && _vm.currentRoute.includes("podcast")
                        ? "active"
                        : "",
                    ],
                    on: {
                      click: function ($event) {
                        return _vm.goTo("/my-create/podcast")
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("my-create.common.navbar.podcast")) +
                        "\n              "
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }